import { AuthPageLayout } from "./AuthPageLayout";
import { LoadingButton } from "./LoadingButton";
import { CodeInputField } from "./CodeInputField";

/**
 * メールコード入力画面
 */
export const EmailCodeUI: React.FC<{
  loading: boolean;
  error: string | null;
  recoverySuggestion: string | null;
  code: string;
  onCodeChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({ loading, error, recoverySuggestion, code, onCodeChange, onSubmit, onCancel }) => {
  return (
    <AuthPageLayout>
      {/* タイトル */}
      <h2 className="text-3xl font-bold text-center text-neutral-900 mb-4">
        メールで認証コードを確認
      </h2>
      <p className="text-center text-neutral-600 mb-8">
        登録されているメールアドレスに認証コードを送信しました
      </p>

      {/* フォーム */}
      <form onSubmit={onSubmit} className="space-y-6">
        {/* メールコード */}
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            認証コード
          </label>
          <CodeInputField
            value={code}
            onChange={onCodeChange}
            disabled={loading}
            placeholder="000000"
          />
        </div>

        {/* エラーメッセージ */}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {recoverySuggestion && (
          <div className="text-sm text-neutral-700">{recoverySuggestion}</div>
        )}

        {/* ボタン */}
        <div className="space-y-3">
          <LoadingButton loading={loading} loadingMessage="確認中..." label="確認する" />

          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white py-4 rounded-2xl text-xl font-bold transition-colors"
            disabled={loading}
          >
            キャンセル
          </button>
        </div>
      </form>
    </AuthPageLayout>
  );
};
